import { dataHooks } from '../../../../libs/dataHooks';

export const templatesGridDataHooks = dataHooks<{
  template: {};
  banner: {};
}>('templates-grid');
